"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFinalClaimUpdate = exports.finalClaimUpdateSchema = void 0;
var schema_validator_1 = require("@hobt/schema-validator");
var mandatory_documentation_1 = require("./mandatory-documentation");
// TODO: add all updatable sub-documents to finalClaimUpdateSchema
exports.finalClaimUpdateSchema = {
    type: 'object',
    // TODO: Make "mandatoryDocumentation" require again; for now it's optional to accommodate the current state of the front-end
    required: [],
    properties: {
        mandatoryDocumentation: mandatory_documentation_1.mandatoryDocumentationSchema,
    },
};
exports.validateFinalClaimUpdate = function (data) {
    var finalClaimValidator = new schema_validator_1.SchemaValidator(exports.finalClaimUpdateSchema, true, false, true, true);
    return finalClaimValidator.validate(data);
};
